// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

body > iframe {
  display: none;
}

ul,
ol {
  padding: 0.5rem 1rem;
}

.flex--column {
  display: flex;
  flex-direction: column;
  grid-gap: 0.5rem;
}

.flex--row {
  display: flex;
  flex-direction: row;
  grid-gap: 0.5rem;
}

.grey {
  color: rgba(21, 21, 21, 0.5019607843);
}

.white {
  color: #fbfbfb;
  text-decoration-color: #fbfbfb;
}

.center {
  text-align: center;
}

.wavy {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: #fbfbfb; /* Опционально, чтобы задать цвет */
  text-underline-offset: 4px;
  text-decoration-thickness: 1.5px;
}

a:link,
a:hover,
a:visited,
a:active {
  text-underline-offset: 4px;
  text-decoration-thickness: 2px;
}

img {
  max-width: 100%;
  max-height: 100%;
}

@media all and (min-width: 1280px) {
  .br--mobile {
    display: none;
  }
}

.br--desktop {
  display: none;
}
@media all and (min-width: 1280px) {
  .br--desktop {
    display: block;
  }
}

.black-50 {
  color: rgba(21, 21, 21, 0.5019607843);
}

.center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/general.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AADF;;AAIA;EACE,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAKA;EACE,aAAA;AAFF;;AAKA;;EAEE,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qCCVS;ADQX;;AAKA;EACE,cCVU;EDWV,8BCXU;ADSZ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,+BAAA;EACA,2BAAA;EACA,8BCrBU,EDqByB,mCAAA;EACnC,0BAAA;EACA,gCAAA;AAFF;;AAKA;;;;EAIE,0BAAA;EACA,8BAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAME;EADF;IAEI,aAAA;EAFF;AACF;;AAKA;EACE,aAAA;AAFF;AAIE;EAHF;IAII,cAAA;EADF;AACF;;AAIA;EACE,qCC1DS;ADyDX;;AAIA;EACE,kBAAA;AADF","sourcesContent":["@import \"src/styles/variables\";\n//@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Unbounded:wght@200..900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// скрываем оверлей \"development error\"\nbody > iframe {\n  display: none;\n}\n\nul,\nol {\n  padding: 0.5rem 1rem;\n}\n\n.flex--column {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 0.5rem;\n}\n\n.flex--row {\n  display: flex;\n  flex-direction: row;\n  grid-gap: 0.5rem;\n}\n\n.grey {\n  color: $black-50;\n}\n\n.white {\n  color: $white-100;\n  text-decoration-color: $white-100;\n}\n\n.center {\n  text-align: center;\n}\n\n.wavy {\n  text-decoration-line: underline;\n  text-decoration-style: wavy;\n  text-decoration-color: $white-100; /* Опционально, чтобы задать цвет */\n  text-underline-offset: 4px;\n  text-decoration-thickness: 1.5px;\n}\n\na:link,\na:hover,\na:visited,\na:active {\n  text-underline-offset: 4px;\n  text-decoration-thickness: 2px;\n}\n\nimg {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.br--mobile {\n  @media all and (min-width: $desktop) {\n    display: none;\n  }\n}\n\n.br--desktop {\n  display: none;\n\n  @media all and (min-width: $desktop) {\n    display: block;\n  }\n}\n\n.black-50 {\n  color: $black-50;\n}\n\n.center {\n  text-align: center;\n}\n","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
